// Canonical product price logic — mirrors the backend Product::final_price
// (sale_price whenever it is set, otherwise the regular price).
//
// Use these helpers everywhere a product price is displayed or charged so the
// frontend and backend never disagree on the amount.

/** Regular (MRP) price as a number. */
export const getRegularPrice = (product) => {
  const p = Number(product?.price);
  return Number.isFinite(p) ? p : 0;
};

/** Sale price as a positive number, or null when not set. */
export const getSalePrice = (product) => {
  const sp = Number(product?.sale_price);
  return Number.isFinite(sp) && sp > 0 ? sp : null;
};

/**
 * Final price actually charged for the product.
 * Uses sale_price whenever it is set (even if it is not lower than the
 * regular price), matching the backend. Falls back to the regular price.
 */
export const getFinalPrice = (product) => {
  const sale = getSalePrice(product);
  return sale != null ? sale : getRegularPrice(product);
};

/**
 * True only when there is a genuine discount to advertise — i.e. the sale
 * price is set AND below the regular price. Drives the struck-through MRP.
 */
export const hasDiscount = (product) => {
  const sale = getSalePrice(product);
  return sale != null && getRegularPrice(product) > sale;
};

/** Discount percentage (0 when there is no genuine discount). */
export const getDiscountPercent = (product) => {
  if (!hasDiscount(product)) return 0;
  const price = getRegularPrice(product);
  const sale = getSalePrice(product);
  return Math.round(((price - sale) / price) * 100);
};
